import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { Context } from '../index';
import { getCategoriesForAdmin } from '../http/adminChatCategoryAccessAPI';

const ChatCategoryGuard = ({ children }) => {
  const { user } = useContext(Context);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      // Если нет параметра категории, доступ открыт (общая страница чатов)
      if (!categoryId) {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      // Владелец имеет доступ ко всем категориям
      if (user.user?.access?.isOwner) {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      try {
        // Проверяем доступ к конкретной категории
        const adminCategories = await getCategoriesForAdmin(user.user.id);
        const hasAccessToCategory = adminCategories.some(cat => cat.id === categoryId);
        setHasAccess(hasAccessToCategory);
      } catch (error) {
        console.error('Ошибка проверки доступа к категории:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    if (user.user?.id) {
      checkAccess();
    }
  }, [categoryId, user.user?.id, user.user?.access?.isOwner]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ChatCategoryGuard;
